import CalendarDelete from './CalendarDelete'
export {CalendarDelete}
export default CalendarDelete
